// extracted by mini-css-extract-plugin
export var menuIcon = "_u9-0";
export var menuIconInline = "_u9-1";